import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';

export default function AccessOptionsHintModal({show, onHide}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Trans i18nKey="p.s.uiconfiguration.getskinresult.access.options.hint.title">
            Access Options Required
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <Trans i18nKey="p.s.uiconfiguration.getskinresult.access.options.hint.desc">
            At least one access option must be enabled. Please adjust your
            settings before saving.
          </Trans>
        </p>
      </Modal.Body>
    </Modal>
  );
}
